var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('q-input',{attrs:{"outlined":"","label":"Basis Recommendation","rules":[ val=> val!=='' && val!==null ]},model:{value:(_vm.StoreStateCD.BasisRecommendation),callback:function ($$v) {_vm.$set(_vm.StoreStateCD, "BasisRecommendation", $$v)},expression:"StoreStateCD.BasisRecommendation"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }